import { render } from "./areaAdd.vue?vue&type=template&id=48323c64&scoped=true&ts=true"
import script from "./areaAdd.vue?vue&type=script&lang=ts"
export * from "./areaAdd.vue?vue&type=script&lang=ts"

import "./areaAdd.vue?vue&type=style&index=0&id=48323c64&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48323c64"]])

export default __exports__